"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsObjectStringKv = void 0;
const class_validator_1 = require("class-validator");
function IsObjectStringKv(opts, validationOptions) {
    return function (object, propertyName) {
        if (!opts) {
            opts = {};
        }
        if (typeof opts.keyRegex === 'string') {
            opts.keyRegex = new RegExp('^' + opts.keyRegex.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        }
        (0, class_validator_1.registerDecorator)({
            name: 'IsObjectStringKv',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [opts],
            options: {
                message: (args) => {
                    const opts = args.constraints[0];
                    if (opts.keyRegex) {
                        return `$property must be object with strings as both keys and values, and keys matching ${opts.keyRegex.toString()}`;
                    }
                    else {
                        return '$property must be object with strings as both keys and values ';
                    }
                },
                ...validationOptions,
            },
            validator: {
                validate(value, args) {
                    const opts = args.constraints[0];
                    if (typeof value !== 'object') {
                        return false;
                    }
                    for (const [k, v] of Object.entries(value)) {
                        if (typeof k !== 'string') {
                            return false;
                        }
                        if (typeof v !== 'string') {
                            if (!opts.allowNullValues) {
                                return false;
                            }
                            else if (v !== null) {
                                return false;
                            }
                        }
                        if (opts.keyRegex) {
                            if (!opts.keyRegex.test(k)) {
                                return false;
                            }
                        }
                    }
                    return true;
                },
            },
        });
    };
}
exports.IsObjectStringKv = IsObjectStringKv;
//# sourceMappingURL=is-object-string-kv.js.map